import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import { ANALYTICS_DISABLED } from 'my-core/analytics/analytics-constants';
import { useCurrentUser } from 'my-core/hooks';
import { useCurrentUserSubscription } from 'my-core/subscription-utils';
import { install, pageChange, userUpdate } from 'my-core/tag-manager';

export default function TagManager() {
  const user = useCurrentUser();
  const subscription = useCurrentUserSubscription();
  const location = useLocation();

  const initialMountRef = useRef(true);

  useEffect(() => {
    if (ANALYTICS_DISABLED || initialMountRef.current || user.guest) return;
    userUpdate(user, subscription);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, subscription?.status, subscription?.is_premed_plus]);

  useEffect(() => {
    if (ANALYTICS_DISABLED) return;
    if (initialMountRef.current) {
      initialMountRef.current = false;
      install(user, subscription);
    } else {
      pageChange(user, subscription, location);
    }
  }, [location.pathname, location.search, subscription?.status, user.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
